import { z } from 'zod';
export const DepartmentSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    // Owning / "usable-at" branch of this cost center (col B of the master).
    branchId: z.uuid().nullable().optional(),
    code: z.string().min(1).max(32),
    nameTh: z.string().min(1),
    shortCode: z.string().min(1).max(16),
    costCenter: z.string().nullable().optional(),
    head: z.string().nullable().optional(),
    headcount: z.number().int().nonnegative(),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateDepartmentSchema = DepartmentSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateDepartmentSchema = CreateDepartmentSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=department.js.map